import { render } from "./UiConfirm.vue?vue&type=template&id=4de9235c&lang=pug"
import script from "./UiConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./UiConfirm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__